import {Component, Input, OnInit} from '@angular/core';
import {FileDownloaderService} from '../../../../components/admin/file-downloader/file-downloader.service';
import {DateService} from '../../../../services/date.service';

@Component({
  selector: 'app-award-preview',
  templateUrl: './award-preview.component.html',
  styleUrls: ['./award-preview.component.scss']
})
export class AwardPreviewComponent implements OnInit {
  @Input() public award;

  constructor(
    public fileDownloader: FileDownloaderService,
    public dateService: DateService,
  ) {
  }

  ngOnInit(): void {
  }

  public downloadFile(file) {
    this.fileDownloader.addNewFileToDownload(file);
  }
}
